import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "Labelstyles__Container",
  componentId: "keen-widget-settings__sc-1wpr9t3-0"
})(["&&&{min-width:145px;}"]);